module.exports = __webpack_public_path__ + "static/img/hot-code.eb5db212.png";